import { requestApi } from 'api/api'
import { type RequestProps } from '@node-space/rest-api'
import { MultiFactorAuthorizationRequest, MultiFactorAuthorizationRequestError } from 'types/mfa'

export const multiFactorAuthorizationRequest = (
  data: MultiFactorAuthorizationRequest,
  headers?: RequestProps['headers']
): Promise<null | MultiFactorAuthorizationRequestError> => {
  return requestApi({
    url: '',
    baseUrl: data?.mfaCallbackUrl,
    method: 'POST',
    data: {
      challenge: data?.challenge,
      tokenResponse: data?.tokenResponse,
    },
    headers,
  })
}
